import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    brandDeleteRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteBrand = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        brand,
        result,
    } = useSelector(state => state.deleteBrandRedux);

    const handleDelete = () => {
        dispatch(brandDeleteRequest(brand?.id))
    }

    const closeModal = () => {
        dispatch(clearRedux("BRAND_DELETE"))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['brand_delete_success_message'],
                    messages['brand_delete_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
                closeModal()
                dispatch(clearRedux("BRAND_DELETE", { result: null }))
            } else {
                let message = messages['brand_delete_general_error']
                if (result && result?.error && result?.error?.includes("in use")) {
                    if (result?.error?.includes("Dealer")) {
                        message = messages['brand_delete_package_in_use_dealer']
                    }
                    
                }

                NotificationManager.error(
                    message,
                    messages['brand_delete_title'],
                    3000,
                );
                dispatch(clearRedux("BRAND_DELETE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['brand_delete_title']}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['brand_delete_message']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleDelete}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteBrand;


